// extracted by mini-css-extract-plugin
export default {"progress_bar":"ProgressBar_progress_bar__NGyPa","crown":"ProgressBar_crown__+vBfW","progress_bar_percentage":"ProgressBar_progress_bar_percentage__+WALr"};